module.exports = __webpack_public_path__ + "static/img/01.03978b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/01/01.jpg
// module id = kAxZ
// module chunks = 0